import { EditOutlined } from '@ant-design/icons';
import React from 'react';
import { Rule } from 'antd/es/form';

import { Form, Input } from 'antd';
import { PLACEHOLDERS_COPY, TAG_DESCRIPTION } from '@sonar-software/sonar-ts-constants';

export interface TagDescriptionInputProps {
	disabled?: boolean;
	name: string;
}

const lengthRule: Rule = {
	max: TAG_DESCRIPTION.MAX_LENGTH,
	message: TAG_DESCRIPTION.MAX_MESSAGE,
	type: 'string'
};

const rules = [ lengthRule ];

export const TagDescriptionInput: React.FC<TagDescriptionInputProps> = ({ disabled, name }) =>
	<Form.Item
		className='tag-description-input'
		name={ name }
		rules={ rules }>
		<Input
			disabled={ disabled }
			placeholder={ PLACEHOLDERS_COPY.TAG_DESCRIPTION }
			prefix={ disabled ? undefined : <EditOutlined /> }
			type='text' />
	</Form.Item>;

